__turbopack_context__.v({
  "card": "WeitereLeistungen-module__aaF7qW__card",
  "cardText": "WeitereLeistungen-module__aaF7qW__cardText",
  "cardTitle": "WeitereLeistungen-module__aaF7qW__cardTitle",
  "container": "WeitereLeistungen-module__aaF7qW__container",
  "ctaButton": "WeitereLeistungen-module__aaF7qW__ctaButton",
  "ctaPanel": "WeitereLeistungen-module__aaF7qW__ctaPanel",
  "ctaText": "WeitereLeistungen-module__aaF7qW__ctaText",
  "grid": "WeitereLeistungen-module__aaF7qW__grid",
});
